export default __webpack_public_path__ + "static/media/Aboutus.90dda4ce.png";